import axios from "axios";

// Emergent ingress routes /api on the same origin to the backend service in BOTH
// preview and production. Prefer the current browser origin at runtime so a build
// made against the preview URL still works when deployed to a different domain.
function resolveBase() {
  if (typeof window !== "undefined" && window.location && window.location.origin) {
    return window.location.origin;
  }
  return process.env.REACT_APP_BACKEND_URL || "";
}

const BASE = resolveBase();
export const API = `${BASE}/api`;

const client = axios.create({ baseURL: API });

client.interceptors.request.use((config) => {
  const token = localStorage.getItem("hos_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

export default client;

export function formatApiError(err) {
  const detail = err?.response?.data?.detail;
  if (!detail) return err?.message || "Something went wrong";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail)) return detail.map((e) => e?.msg || JSON.stringify(e)).join(", ");
  if (detail?.msg) return detail.msg;
  return String(detail);
}
